import { CountryService } from "./../_services/country.service";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { Product } from "./../_models/product";
import { MatTableDataSource } from "@angular/material/table";
import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { Country } from "../_models/country.js";

@Component({
  selector: "app-country-list-page",
  templateUrl: "./country-list-page.component.html",
  styleUrls: ["./country-list-page.component.scss"],
})
export class CountryListPageComponent implements OnInit {
  constructor(private router: Router, public countryService: CountryService) { }

  displayedColumns = ["Id", "Name", "CountryCode", "CurrencyCode", "formatActive"];
  dataSource: MatTableDataSource<Country>;
  isDataLoaded = false;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource<Country>();
    this.countryService.getCountries().subscribe(
      (countries: Country[]) => {
        this.dataSource.data = countries.map((country) => {
          country.formatActive = country.active ? 'Active' : 'Inactive';
          return country;
        });
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.isDataLoaded = true;
      },
      (err) => {
        console.error("Country: ", err);
        if (err.status == 404) {
          this.dataSource.data = [];
        }
        this.isDataLoaded = true;
      }
    );
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  addCountry() {
    this.router.navigate(["regional", "country", "add"]);
  }

  viewCountry(id: number) {
    this.router.navigate(["regional", "country", id]);
  }
}
